import React, { useEffect } from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

const Auth0ProviderWithHistory = ({ children }) => {
  const navigate = useNavigate();
  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE;
  
  // Add this useEffect to log variables on component mount
  useEffect(() => {
  }, [domain, clientId, audience]);
  
  const onRedirectCallback = (appState) => {
    // Make sure we have a valid returnTo
    const targetUrl = appState?.returnTo || window.location.pathname;
    
    // Navigate to the target URL
    navigate(targetUrl);
    
    // Clear any Auth0 state from the URL to prevent auto sign-in issues
    if (window.history && window.history.replaceState) {
      const url = new URL(window.location.href);
      const cleanParams = new URLSearchParams(url.search);
      
      // Remove Auth0-specific query parameters
      ['code', 'state', 'error', 'error_description'].forEach(param => {
        cleanParams.delete(param);
      });
      
      // Replace the current URL without Auth0 parameters
      const newUrl = `${url.pathname}${cleanParams.toString() ? `?${cleanParams.toString()}` : ''}`;
      window.history.replaceState({}, document.title, newUrl);
    }
  };
  
  // If any auth configuration is missing, show error
  if (!domain || !clientId || !audience) {
    return (
      <div style={{ padding: '20px', color: 'red' }}>
        <h2>Auth0 Configuration Error</h2>
        <p>Missing required Auth0 configuration. Please check your environment variables:</p>
        <ul>
          <li>REACT_APP_AUTH0_DOMAIN: {domain ? '✓' : '✗'}</li>
          <li>REACT_APP_AUTH0_CLIENT_ID: {clientId ? '✓' : '✗'}</li>
          <li>REACT_APP_AUTH0_AUDIENCE: {audience ? '✓' : '✗'}</li>
        </ul>
      </div>
    );
  }
  
  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: audience,
        scope: 'openid profile email offline_access',
      }}
      onRedirectCallback={onRedirectCallback}
      cacheLocation="localstorage"
      useRefreshTokens={true}
      skipRedirectCallback={window.location.pathname === '/callback'}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;